module.exports = __webpack_public_path__ + "img/welcome-step-2.c619d07a.png";